import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

const HowChargesWork = ({ t }) => (
  <section className="crew-size-step__box">
    <Typography component="h2" className="text-label-md crew-size-step__text">
      {t.howChargesWork}
    </Typography>
    <ul className="crew-size-step__charges">
      {t.charges.map((line) => (
        <li key={line} className="text-body-sm crew-size-step__text">
          {line}
        </li>
      ))}
    </ul>
  </section>
);

HowChargesWork.propTypes = {
  t: PropTypes.shape({
    howChargesWork: PropTypes.string,
    charges: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
};

export default HowChargesWork;
